import React from 'react';
import {useIntl} from 'react-intl';
import classNames from 'classnames';
import styles from './styles.module.scss';

export function InfoBox({infoBoxData}) {
  const intl = useIntl();
  const infoBoxTexts = {
    registeredCount: intl.formatMessage({
      id: 'registrationData-info-box-registeredCount', defaultMessage: 'Registered count'
    }),
    completedPersonalInfoCount: intl.formatMessage({
      id: 'registrationData-info-box-completedPersonalInfoCount', defaultMessage: 'Completed personal info count'
    }),
    completedBankInfoCount: intl.formatMessage({
      id: 'registrationData-info-box-completedBankInfoCount', defaultMessage: 'Completed bank info count'
    }),
    completedPracticeAreaInfoCount: intl.formatMessage({
      id: 'registrationData-info-box-completedPracticeAreaInfoCount',
      defaultMessage: 'Completed practice area info count'
    }),
    completedAgreementContractCount: intl.formatMessage({
      id: 'registrationData-info-box-completedAgreementContractCount',
      defaultMessage: 'Completed agreement contract count'
    }),
    completedForm6101Count: intl.formatMessage({
      id: 'registrationData-info-box-completedForm6101Count', defaultMessage: 'Completed form 6101 count'
    }),
    completedForm101Count: intl.formatMessage({
      id: 'registrationData-info-box-completedForm101Count', defaultMessage: 'Completed form 101 count'
    }),
    gotAgentIdCount: intl.formatMessage({
      id: 'registrationData-info-box-gotAgentId', defaultMessage: 'Got agent Id'
    }),
    gotTamalIdCount: intl.formatMessage({
      id: 'registrationData-info-box-gotTamalId', defaultMessage: 'Got tamal Id'
    }),
  };

  return (
    <div className={styles.infoBoxesContainer}>
      <div className={classNames(styles.infoBox, styles.lightOrange)}>
        <div className={styles.title}>{infoBoxTexts.registeredCount}</div>
        <span className={classNames(styles.count, styles.darkOrange)}>
          {infoBoxData.registeredCount}
        </span>
      </div>
      <div className={classNames(styles.infoBox, styles.lightGreen)}>
        <div className={styles.title}>{infoBoxTexts.completedPersonalInfoCount}</div>
        <span className={classNames(styles.count, styles.darkGreen)}>
          {infoBoxData.completedPersonalInfoCount}
        </span>
      </div>
      <div className={classNames(styles.infoBox, styles.lightRed)}>
        <div className={styles.title}>{infoBoxTexts.completedBankInfoCount}</div>
        <span className={classNames(styles.count, styles.darkRed)}>
          {infoBoxData.completedBankInfoCount}
        </span>
      </div>
      <div className={classNames(styles.infoBox, styles.lightViolet)}>
        <div className={styles.title}>{infoBoxTexts.completedPracticeAreaInfoCount}</div>
        <span className={classNames(styles.count, styles.darkViolet)}>
          {infoBoxData.completedPracticeAreaInfoCount}
        </span>
      </div>
      <div/>
      <div className={classNames(styles.infoBox, styles.lightOrange)}>
        <div className={styles.title}>{infoBoxTexts.completedAgreementContractCount}</div>
        <span className={classNames(styles.count, styles.darkOrange)}>
          {infoBoxData.completedAgreementContractCount}
        </span>
      </div>
      <div className={classNames(styles.infoBox, styles.lightGreen)}>
        <div className={styles.title}>{infoBoxTexts.completedForm6101Count}</div>
        <span className={classNames(styles.count, styles.darkGreen)}>
          {infoBoxData.completedForm6101Count}
        </span>
      </div>
      <div className={classNames(styles.infoBox, styles.lightRed)}>
        <div className={styles.title}>{infoBoxTexts.completedForm101Count}</div>
        <span className={classNames(styles.count, styles.darkRed)}>
          {infoBoxData.completedForm101Count}
        </span>
      </div>
      <div className={classNames(styles.infoBox, styles.lightViolet)}>
        <div className={styles.title}>{infoBoxTexts.gotAgentIdCount}</div>
        <span className={classNames(styles.count, styles.darkViolet)}>
          {infoBoxData.gotAgentIdCount}
        </span>
      </div>
      <div className={classNames(styles.infoBox, styles.lightBlue)}>
        <div className={styles.title}>{infoBoxTexts.gotTamalIdCount}</div>
        <span className={classNames(styles.count, styles.darkBlue)}>
          {infoBoxData.gotTamalIdCount}
        </span>
      </div>
    </div>
  );
}
